import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Logo from './Logo';
import { Arrow } from './Icons';

function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <header className="header"><div className="header-inner"><Logo /><button className="menu-toggle" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls="navigation">{open ? 'Close −' : 'Menu +'}</button><nav id="navigation" className={open ? 'navigation open' : 'navigation'} aria-label="Main navigation"><NavLink end to="/">Home</NavLink><NavLink to="/services">Services</NavLink><a href="/#about" onClick={() => setOpen(false)}>About us</a><Link className="button nav-contact" to="/contact">Contact <Arrow diagonal /></Link></nav></div></header>;
}

export default Header;
